import React from 'react';

export default function Emoji({ label, character, ...rest }) {
  return (
    <span role="img" aria-label={label} {...rest}>
      {character}
    </span>
  );
}
